// src/components/NewsBuddyLogo.jsx
import React from 'react';

export default function NewsBuddyLogo() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        {/* Gradient for the outer circle */}
        <linearGradient id="nbGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#34D399" />  {/* Emerald green */}
          <stop offset="100%" stopColor="#00C14C" /> {/* Darker emerald */}
        </linearGradient>
      </defs>

      {/* Outer circle with gradient fill and white stroke */}
      <circle
        cx="60"
        cy="60"
        r="58"
        fill="url(#nbGradient)"
        stroke="white"
        strokeWidth="4"
      />

      {/* Newspaper (friendly buddy) icon group */}
      <g transform="translate(20,30)">
        {/* Newspaper body */}
        <rect
          x="0"
          y="0"
          width="80"
          height="60"
          rx="5"
          fill="white"
          stroke="#00C14C"
          strokeWidth="2"
        />
        {/* Folded corner (dog-ear) on the top right */}
        <polygon
          points="80,0 80,15 65,0"
          fill="#00C14C"
        />

        {/* Friendly facial features on the newspaper */}
        {/* Eyes */}
        <circle cx="25" cy="22" r="3" fill="#00C14C" />
        <circle cx="55" cy="22" r="3" fill="#00C14C" />

        {/* Smile */}
        <path
          d="M25 35 Q40 45 55 35"
          stroke="#00C14C"
          strokeWidth="2"
          fill="none"
          strokeLinecap="round"
        />

        {/* Headline and text lines below the face */}
        <line
          x1="10"
          y1="48"
          x2="70"
          y2="48"
          stroke="#00C14C"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <line
          x1="10"
          y1="56"
          x2="60"
          y2="56"
          stroke="#00C14C"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
}
